import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DashboardDemo from './pages/DashboardDemo';
import ProductMasterDemo from './pages/ProductMasterDemo';
import InwardManagementDemo from './pages/InwardManagementDemo';
import OutwardManagementDemo from './pages/OutwardManagementDemo';
import ReturnManagementDemo from './pages/ReturnManagementDemo';
import PutawayManagementDemo from './pages/PutawayManagementDemo';
import BinManagementDemo from './pages/BinManagementDemo';
import ReportsDemo from './pages/ReportsDemo';

function App() {
  return (
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routes>
        <Route path="/" element={<DashboardDemo />} />
        <Route path="/products" element={<ProductMasterDemo />} />
        <Route path="/inward" element={<InwardManagementDemo />} />
        <Route path="/outward" element={<OutwardManagementDemo />} />
        <Route path="/returns" element={<ReturnManagementDemo />} />
        <Route path="/putaway" element={<PutawayManagementDemo />} />
        <Route path="/bins" element={<BinManagementDemo />} />
        <Route path="/reports" element={<ReportsDemo />} />
      </Routes>
    </Router>
  );
}

export default App;
